import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@xxtract/ui';
import { aggregateKpiDataState, formatPercent, formatWorkdays } from '../format';
import type { KpiSummary } from '../processes.api';

/** Leeftijd lopend werk (spec-processen-actuele-stand CAP-7): werkdagen sinds ontvangst tot nu en
 * het aandeel lopend binnen de norm, alleen over lopende orders. Geen doorlooptijd van afgerond werk. */
export function KpiSummaryBlock({ kpiSummary }: { kpiSummary: KpiSummary }) {
  const { t } = useTranslation();
  const dataKpiState = aggregateKpiDataState(kpiSummary);

  return (
    <Card data-kpi-state={dataKpiState ?? undefined} data-testid="process-detail-kpi">
      <CardHeader>
        <CardTitle>{t('processes.detail.kpiTitle')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {kpiSummary.total === 0 ? (
          <p className="text-xs text-[var(--foreground-muted)]">{t('processes.placeholder.notYetAvailable')}</p>
        ) : (
          <>
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
              <div>
                <p className="text-[11px] text-[var(--foreground-muted)]">{t('processes.kpi.meanWorkdays')}</p>
                <p className="text-lg font-semibold text-[var(--foreground)]">
                  {kpiSummary.meanWorkdays != null ? formatWorkdays(kpiSummary.meanWorkdays) : t('common.notAvailable')}
                </p>
              </div>
              <div>
                <p className="text-[11px] text-[var(--foreground-muted)]">{t('processes.kpi.pctWithinKpi')}</p>
                <p className="text-lg font-semibold text-[var(--foreground)]">
                  {kpiSummary.pctWithinKpi != null ? formatPercent(kpiSummary.pctWithinKpi) : t('common.notAvailable')}
                </p>
              </div>
              <div>
                <p className="text-[11px] text-[var(--foreground-muted)]">{t('processes.kpi.overKpiCount')}</p>
                <p className="text-lg font-semibold text-[var(--foreground)]">{kpiSummary.overKpiCount}</p>
              </div>
              <div>
                <p className="text-[11px] text-[var(--foreground-muted)]">{t('processes.kpi.stuckCount')}</p>
                <p className="text-lg font-semibold text-[var(--foreground)]">{kpiSummary.stuckCount}</p>
              </div>
              <div>
                <p className="text-[11px] text-[var(--foreground-muted)]">{t('processes.kpi.notReceivedCount')}</p>
                <p className="text-lg font-semibold text-[var(--foreground)]">{kpiSummary.notReceivedCount}</p>
              </div>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
